import React, { Component } from 'react';
import Parser from 'html-react-parser'
import { ChevronRightIcon, DocumentIcon, BuildingDocumentIcon, PackageIcon, ExchangeIcon } from './SVGIcons';
import OffcanvasForm from './OffcanvasForm';

class First extends Component {
  static defaultProps = {

  }

  state = {
    showCallForm: false,
    callFormTitle: "Запросить коммерческое предложение"
  }

  constructor(props) {
    super(props)
  }

  // Метод для открытия формы
  openCallForm = (title) => {
    this.setState({ callFormTitle: title, showCallForm: true });
  };

  // Метод для закрытия формы
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    this.closeCallForm();
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {

    const { showCallForm, callFormTitle } = this.state
    const data = this.props?.data || {}
    const sotrudnichestvo = data?.sotrudnichestvo || []
    const links = data?.links || {}

    return (
      <>
        <div className='mt-[40px] w-full'>
          <div className='container'>
            <div className='flex flex-col lg:flex-row items-start lg:items-end justify-between gap-[20px] lg:gap-0'>
              <div className='w-full lg:w-auto'>
                <div className='text-title text-ptblack uppercase tracking-tight'>{Parser(data?.h1 || data?.pagetitle)}</div>
                <div className='text-base text-ptgray mt-[12px] max-w-[742px] leading-none'>
                  {Parser(data?.introtext || '')}
                </div>
              </div>
              <a href={links?.documenti} className='cursor-pointer bg-[#F6F7F8] duration-300 ease-in-out hover:bg-[#DBE7F3] px-[22px] h-[48px] w-full lg:w-auto flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-[#001553]'>
                <div className='text-base'>Ознакомиться с документами</div>
                <ChevronRightIcon width={6} height={12} stroke="currentColor" />
              </a>
            </div>
            <div className='mt-[40px] flex flex-col lg:flex-row gap-[20px]'>
              <div className='w-full lg:flex-auto'>
                <div
                  className='w-full bg-[#BC0005] rounded-[14px] min-h-[182px] p-[20px] flex flex-col justify-between items-center bg-cover bg-center'
                  style={{ backgroundImage: `url('${sotrudnichestvo[0]?.image}')` }}
                >
                  <div className='flex justify-end items-start w-full text-white'>
                    <BuildingDocumentIcon width={24} height={24} stroke="currentColor" />
                  </div>
                  <div className='leading-none w-full'>
                    <div className='text-cardTitle text-white uppercase'>
                      {Parser(sotrudnichestvo[0]?.title || '')}
                    </div>
                    <div className='text-white/75 text-base mt-[12px]'>
                      {Parser(sotrudnichestvo[0]?.text || '')}
                    </div>
                  </div>
                </div>
                <div className='w-full bg-[#F6F7F8] rounded-[14px] min-h-[162px] p-[20px] flex flex-col justify-between items-center mt-[20px]'>
                  <div className='flex justify-end w-full text-[#001553]'>
                    <PackageIcon width={24} height={24} stroke="currentColor" />
                  </div>
                  <div className='leading-none w-full'>
                    <div className='text-cardTitle text-ptblack uppercase'>{Parser(sotrudnichestvo[1]?.title || '')}</div>
                    <div className='text-ptgray text-base mt-[12px]'>
                      {Parser(sotrudnichestvo[1]?.text || '')}
                    </div>
                  </div>
                </div>
              </div>
              <div className='w-full lg:w-[405px] flex-none leading-none'>
                <div className='text-cardTitle text-ptblack uppercase'>{Parser(sotrudnichestvo[2]?.title || '')}</div>
                <ul className='text-base text-ptgray mt-[20px] list-disc pl-[20px]'>
                  {Parser(sotrudnichestvo[2]?.text || '')}
                </ul>
                <div
                  className='w-full bg-[#001553] rounded-[14px] min-h-[222px] p-[20px] bg-cover bg-center mt-[27px]'
                  style={{ backgroundImage: `url('${sotrudnichestvo[2]?.image}')` }}
                >
                  <div className='w-full'>
                    <div className='flex items-center justify-between w-full text-white'>
                      <div className='text-cardTitle uppercase'>
                        Документы <span className='text-white/75'>для закупки</span>
                      </div>
                      <DocumentIcon width={24} height={24} stroke="currentColor" />
                    </div>
                    <div className='text-white/75 text-base mt-[12px]'>
                      Предоставляем <span className='text-white'>комплект документов</span>, который обычно требуется юрлицам:
                    </div>
                    <div className='w-full bg-white rounded-[14px] lg:min-h-[100px] p-[20px] mt-[20px]'>
                      <ul className='text-base text-ptgray list-disc pl-[20px]'>
                        {Parser(sotrudnichestvo[2]?.text2 || '')}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Блок с ценами */}
            <div style={{ backgroundImage: `url('${sotrudnichestvo[3]?.image}')` }} className='bg-cover bg-center w-full mt-[60px] bg-[#001553] rounded-[14px] flex flex-col lg:flex-row items-center justify-between gap-[19px] p-[20px]'>
              <div className='leading-none text-left w-full lg:w-auto'>
                <div className='text-white font-light text-cardTitle uppercase'>{Parser(sotrudnichestvo[3]?.title || '')}</div>
                <div className='mt-[12px] text-base text-white/60 max-w-[568px]'>
                  {Parser(sotrudnichestvo[3]?.text || '')}
                </div>
              </div>
              <div onClick={() => this.openCallForm("Запросить коммерческое предложение")} className='cursor-pointer w-full lg:max-w-[343px] flex-auto bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[22px] h-[48px] flex items-center justify-center rounded-[14px] gap-[12px] text-white transition-colors'>
                <DocumentIcon width={16} height={16} stroke="currentColor" />
                <div className='text-base'>Запросить КП</div>
              </div>
            </div>

            <div className='w-full flex flex-col lg:flex-row gap-[40px] mt-[100px] leading-none'>
              <div className='w-full lg:flex-auto'>
                <div className='text-title text-ptblack uppercase'>
                  {Parser(sotrudnichestvo[4]?.title || '')}
                </div>
                <div className='text-base text-ptgray mt-[12px]'>
                  {Parser(sotrudnichestvo[4]?.text || '')}
                </div>
                <div className='mt-[40px] flex w-full justify-start'>
                  <div onClick={() => this.openCallForm("Получить консультацию")} className='cursor-pointer w-full lg:w-auto bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[22px] h-[48px] flex items-center justify-center rounded-[14px] gap-[12px] text-white transition-colors'>
                    <DocumentIcon width={16} height={16} stroke="currentColor" />
                    <div className='text-base'>Проконсультироваться</div>
                  </div>
                </div>
              </div>
              <div className='flex flex-col lg:flex-row items-start gap-[21px] w-full lg:w-auto'>
                <div
                  className='w-full lg:w-[284px] bg-[#001553] rounded-[14px] lg:min-h-[219px] gap-[12px] p-[20px] flex flex-col justify-between items-center bg-cover bg-center'
                  style={{ backgroundImage: `url('${sotrudnichestvo[5]?.image}')` }}
                >
                  <div className='flex justify-start items-start w-full text-white'>
                    <div className='text-cardTitle text-white uppercase'>
                      {Parser(sotrudnichestvo[5]?.title || '')}
                    </div>
                  </div>
                  <div className='leading-none w-full'>
                    <div className='text-white/75 text-base'>
                      {Parser(sotrudnichestvo[5]?.text || '')}
                    </div>
                  </div>
                </div>
                <div className='w-full lg:w-[207px] bg-[#F6F7F8] rounded-[14px] lg:min-h-[219px] gap-[22px] p-[20px] flex flex-col justify-between items-center bg-cover bg-center'>
                  <div className='leading-none w-full flex lg:hidden justify-end items-start text-[#001553]'>
                    <ExchangeIcon width={24} height={24} stroke="currentColor" />
                  </div>
                  <div className='flex justify-start items-start w-full text-white'>
                    <div className='text-ptgray text-base'>
                      {Parser(sotrudnichestvo[5]?.text2 || '')}
                    </div>
                  </div>
                  <div className='leading-none w-full hidden lg:flex justify-end items-start text-[#001553]'>
                    <ExchangeIcon width={24} height={24} stroke="currentColor" />
                  </div>
                </div>
              </div>
            </div>

            <div className='mt-[60px] grid grid-cols-1 md:grid-cols-2 gap-[20px] leading-none'>
              <div
                className='bg-cover bg-center rounded-[14px] overflow-hidden'
                style={{ backgroundImage: `url('${sotrudnichestvo[6]?.image}')` }}
              >
                <div className='w-full min-h-[200px] p-[20px] bg-gradient-to-t from-[#00135133]/20 to-[#00071E] flex flex-col justify-start items-start'>
                  <div className='text-cardTitle text-white uppercase leading-none max-w-[272px]'>
                    {Parser(sotrudnichestvo[6]?.title || '')}
                  </div>
                  <div className='mt-[12px] text-base text-white/60 max-w-[334px]'>
                    {Parser(sotrudnichestvo[6]?.text || '')}
                  </div>
                </div>
              </div>
              <div
                className='bg-cover bg-center rounded-[14px] overflow-hidden'
                style={{ backgroundImage: `url('${sotrudnichestvo[7]?.image}')` }}
              >
                <div className='w-full min-h-[200px] p-[20px] bg-gradient-to-t from-[#00135133]/20 to-[#00071E] flex flex-col justify-start items-start'>
                  <div className='text-cardTitle text-white uppercase leading-none max-w-[272px]'>
                    {Parser(sotrudnichestvo[7]?.title || '')}
                  </div>
                  <div className='mt-[12px] text-base text-white/60 max-w-[433px]'>
                    {Parser(sotrudnichestvo[7]?.text || '')}
                  </div>
                </div>
              </div>
            </div>

            <div className='w-full flex flex-col xl:flex-row lg:flex- items-start mt-[20px] leading-none gap-[20px]'>
              <div className='flex-auto w-full lg:w-auto bg-[#F6F7F8] rounded-[14px] min-h-[98px] p-[20px] flex flex-col justify-start items-start bg-cover bg-center'>
                <div className='text-cardTitle text-ptblack uppercase'>{Parser(sotrudnichestvo[8]?.title || '')}</div>
                <div className='text-ptgray text-base mt-[12px]'>
                  {Parser(sotrudnichestvo[8]?.text || '')}
                </div>
              </div>
              <div className='flex flex-wrap md:flex-nowrap items-center justify-center lg:justify-start gap-[20px] w-full lg:w-auto'>
                <img src={sotrudnichestvo[9]?.image} alt='' className='flex-none w-[163px] md:w-[100px] h-auto' width={100} height={98} />
                <img src={sotrudnichestvo[10]?.image} alt='' className='flex-none w-[163px] md:w-[98px] h-auto' width={98} height={98} />
                <img src={sotrudnichestvo[11]?.image} alt='' className='flex-none w-[250px] md:w-[308px] h-auto' width={308} height={98} />
                <img src={sotrudnichestvo[12]?.image} alt='' className='flex-none w-[76px] md:w-[98px] h-auto' width={98} height={98} />
              </div>
            </div>
          </div>
        </div>

        {/* Форма OffcanvasForm */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle={callFormTitle}
          formText="Укажите контактные данные — мы свяжемся с вами для подготовки коммерческого предложения или консультации."
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    )
  }
}

export default First;